import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from 'services/api';

const STATUT_COLORS = { brouillon: '#9e9e9e', en_cours: '#1565c0', termine: '#2e7d32', archive: '#616161' };
const NIVEAU_COLORS = { faible: '#22C55E', moyen: '#F59E0B', eleve: '#EF4444', critique: '#991B1B' };

export default function AuditsPage() {
  const navigate = useNavigate();
  const [audits, setAudits] = useState([]);
  const [stats, setStats] = useState({});
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const [aRes, sRes] = await Promise.all([
        api.get('/audits', { params: { search: search || undefined } }),
        api.get('/audits/stats'),
      ]);
      setAudits(aRes.data);
      setStats(sRes.data);
    } catch {} finally { setLoading(false); }
  }, [search]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="stats-grid">
        {[
          { label: 'Total audits', value: stats.total || 0, cls: 'red' },
          { label: 'En cours', value: stats.en_cours || 0, cls: 'blue' },
          { label: 'Terminés', value: stats.termines || 0, cls: 'green' },
          { label: 'Brouillons', value: stats.brouillons || 0, cls: 'orange' },
        ].map(s => (
          <div className="stat-card" key={s.label}>
            <div className="stat-card-header"><span className="stat-card-label">{s.label}</span>
              <div className={`stat-card-icon ${s.cls}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg></div>
            </div>
            <div className="stat-card-value">{s.value}</div>
          </div>
        ))}
      </div>

      <div className="content-card">
        <div className="gss-toolbar">
          <input className="gss-input" placeholder="Rechercher un audit..." value={search} onChange={e => setSearch(e.target.value)} />
          <button className="gss-btn gss-btn-primary" onClick={() => navigate('/audit/nouveau')}>+ Nouvel audit</button>
        </div>

        {loading ? (
          <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Chargement...</p>
        ) : audits.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 20px' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#DDD" strokeWidth="1.5" style={{ marginBottom: 16 }}><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
            <div style={{ fontSize: 16, fontWeight: 600, color: '#666' }}>Aucun audit</div>
          </div>
        ) : (
          <div className="gss-table-wrap">
            <table className="gss-table">
              <thead>
                <tr><th>Numéro</th><th>Client</th><th>Secteur</th><th>Date visite</th><th>Score</th><th>Niveau</th><th>Auditeur</th><th>Statut</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {audits.map(a => (
                  <tr key={a.id}>
                    <td><strong>{a.numero}</strong></td>
                    <td>{a.client_nom || '-'}</td>
                    <td>{a.secteur_activite || '-'}</td>
                    <td>{a.date_visite?.split('T')[0] || '-'}</td>
                    <td><strong style={{ color: NIVEAU_COLORS[a.niveau_risque] || '#666' }}>{a.score_total || 0}/100</strong></td>
                    <td>{a.niveau_risque && <span className="gss-badge" style={{ background: (NIVEAU_COLORS[a.niveau_risque] || '#999') + '20', color: NIVEAU_COLORS[a.niveau_risque] }}>{a.niveau_risque?.toUpperCase()}</span>}</td>
                    <td>{a.auditeur_prenom ? `${a.auditeur_prenom} ${a.auditeur_nom}` : '-'}</td>
                    <td><span className="gss-badge" style={{ background: (STATUT_COLORS[a.statut] || '#999') + '20', color: STATUT_COLORS[a.statut] }}>{a.statut}</span></td>
                    <td>
                      <div className="gss-actions">
                        {a.statut === 'termine' && (
                          <button className="gss-btn-icon" onClick={() => navigate(`/audit/${a.id}/plan`)} title="Voir le plan">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                          </button>
                        )}
                        <button className="gss-btn-icon" onClick={() => navigate(`/audit/${a.id}/plan`)} title="Détail">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
